<template>
    <div class="home">
        <swiper class="swiper-container" ref="mySwiper" :options="swiperOptions">
            <swiper-slide class="swiper-slide page1">
                <img src="http://oss.pchenidea.com/p1-left.png" alt="" class="pl">

                <img src="http://oss.pchenidea.com/p1-b.png" alt="" class="pb">
                <img src="http://oss.pchenidea.com/p1-right.png" alt="" class="pr  ani" style="z-index: 2"  swiper-animate-delay="5s"  swiper-animate-effect="xian" >
                <img src="http://oss.pchenidea.com/p1-right1.png" alt="" class="pr ani "  swiper-animate-delay="5s"  swiper-animate-effect="yin"  >

                <img src="http://oss.pchenidea.com/logo.png" alt="" class="logo" style="z-index: 100">
                 <div class="wraper ani" swiper-animate-effect="vertical-animation "  swiper-animate-duration="7s">
                     <img src="http://oss.pchenidea.com/tub.png" alt="" class="guang item ani" swiper-animate-effect="hor-animation" swiper-animate-duration="7s">
                 </div>

                <div class="nav q2  c" @click="toPath('/mainIn')">
                    <img src="http://oss.pchenidea.com/qq.png" alt=" " class="quan" />

                    <img src="http://oss.pchenidea.com/mT1.png" alt=" " class="mT" />
                </div>
                <div class="nav q3 c" @click="toPath('/zp')">
                    <img src="http://oss.pchenidea.com/qq.png" alt=" " class="quan" />
                    <img src="http://oss.pchenidea.com/mT2.png" alt=" " class="mT" />

                </div>
                <div class="nav q1  c" @click="toPath('/info')">
                    <img src="http://oss.pchenidea.com/qq.png" alt=" " class="quan" />
                    <img src="http://oss.pchenidea.com/mT3.png" alt=" " class="mT" />

                </div>

            </swiper-slide>
            <swiper-slide class="swiper-slide page2">
                <img src="http://oss.pchenidea.com/p2-1.png" alt="" class="p1">
                <img src="http://oss.pchenidea.com/p2-2.png" alt="" class="p2">
                <div swiper-animate-effect="slideInRight" swiper-animate-duration="1.5s" class="p2-wrap ani"
                     style="overflow: hidden">
                    <img swiper-animate-delay="1.5s" swiper-animate-effect="flash" swiper-animate-duration="0.5s"
                         src="http://oss.pchenidea.com/p2-g.png" alt="" class="p3-g ani">
                    <img src="http://oss.pchenidea.com/p2-3.png" alt="" class="p3">

                </div>
                <img src="http://oss.pchenidea.com/p2-s.png" alt="" class="msg c" @click="toPath('/mainIn')">

            </swiper-slide>
            <swiper-slide class="swiper-slide page2-game">
                <div class="game-section" @click="toPath('/game')">
                    <div class="game-text">
                        <h3 class="game-title">车载云游戏：重新定义智能座舱娱乐体验</h3>
                        <p class="game-desc">依托自研游戏云化聚合平台与核心技术能力，为车企提供车规级云端3A游戏解决方案，让用户在安全场景下畅享高品质互动娱乐</p>
                    </div>
                    <div class="game-media">
                        <img class="game-cover-left" :src="gameImg3" alt="车载云游戏配图">
                        <img class="game-cover" :src="gameImg" alt="车载云游戏">
                        <img class="game-cover-small" :src="gameImg2" alt="车载云游戏配图">
                    </div>
                </div>
            </swiper-slide>

            <swiper-slide class="swiper-slide page3">
                <img src="http://oss.pchenidea.com/p3-1.png" alt="" class="p1">
                <img src="http://oss.pchenidea.com/p3-2.png" alt="" class="p2">

                <img src="http://oss.pchenidea.com/p3-3.png" alt="" swiper-animate-effect="tada"  swiper-animate-delay="1s" swiper-animate-duration="1.5s"
                     class="p3 ani">
                <img src="http://oss.pchenidea.com/p3-s.png" alt="" class="msg c" @click="toPath('/zp')">

            </swiper-slide>
            <swiper-slide class="swiper-slide page4">
                <img src="http://oss.pchenidea.com/p4-1.png" alt="" class="p1">
                <img src="http://oss.pchenidea.com/p4-2.png" alt="" class="p2">
                <img src="http://oss.pchenidea.com/p4-3.png" alt="" class="p3">
                <img src="http://oss.pchenidea.com/p4-s.png" alt="" class="msg c" @click="toPath('/info')">
                <a  class="footer" href="http://beian.miit.gov.cn" target="_blank" style="font-weight: 400;"> 苏ICP备2022011286号-1</a>

            </swiper-slide>
            <!--      <div class="swiper-pagination" slot="pagination"></div>-->
        </swiper>
    </div>
</template>

<script>
    // @ is an alias to /src
    import * as swiperAni from '../assets/swiper.animate.min' //根据自己的路径进行引入
    import gameImg from '@/assets/game.jpg'
    import gameImg2 from '@/assets/game2.png'
    import gameImg3 from '@/assets/game3.png'

    export default {
        name: 'HomeView',

        data() {
            return {
                gameImg,
                gameImg2,
                gameImg3,
                swiperOptions: {
                    direction: 'vertical',
                    speed:500,
                    // preventInteractionOnTransition : true,
                    // preventInteractionOnTransition: true,
                    mousewheel: true,
                    pagination: {
                        el: '.swiper-pagination',    //与slot="pagination"处 class 一致
                        clickable: true,            //轮播按钮支持点击
                    },
                    on: {
                        init: function () {
                            swiperAni.swiperAnimateCache(this)
                            swiperAni.swiperAnimate(this)
                        },
                        slideChange: function (swiper) {
                            swiperAni.swiperAnimate(this)

                            }
                    }
                }
            };
        },
        computed: {
            swiper() {
                return this.$refs.mySwSwiperiper.swiper
            }
        },
        methods: {
            toPath(path) {
                let news = this.$router.resolve({path});
                window.open(news.href,'_blank')
            }
        }
    }
</script>
<style scoped>
    .c{
        cursor:pointer
    }
    .quan{
        position: absolute;
        width: 100%;

    }
    .mT{
        width: 92px;
    }
    .wraper {
        width: 195px;
        position: absolute;
        z-index: 10;
        bottom: 280px;
        left: 544px;
        /*animation: vertical-animation 4s ease-in 1s 1 forwards;*/
        /*-webkit-animation: vertical-animation 4s ease-in 1s 1 forwards;*/
        /*-moz-animation: vertical-animation 4s ease-in 1s 1 forwards;*/

    }

    /*.wraper .item {*/
    /*    animation: hor-animation 4s linear 1s 1 forwards;*/
    /*    animation-fill-mode:forwards;*/
    /*    -webkit-animation: hor-animation 4s linear 1s 1 forwards;*/
    /*    -moz-animation: hor-animation 4s linear 1s 1 forwards;*/
    /*}*/
    .hor-animation{
        -webkit-animation-name: hor-animation;
        animation-name: hor-animation;
    }
    .vertical-animation{
        -webkit-animation-name: vertical-animation;
        animation-name: vertical-animation;
    }
    @-moz-keyframes hor-animation {
        0% { transform: translateX(0px);     }
        100% { transform: translateX(1000px);}
    }
    @-webkit-keyframes hor-animation {
        0% { transform: translateX(0px);     }
        100% { transform: translateX(1000px);opacity: 0; }
    }

    .xian {
        -webkit-animation-name: xian;
        animation-name: xian;

    }
    @-moz-keyframes xian {
        0% {opacity:0  }
        100% {opacity:1  }

    }
    @-webkit-keyframes xian {
        0% {opacity:0  }
        100% {opacity:1  }

    }
    @-webkit-keyframes yin {
        0% {opacity:1 }
        100% {opacity:0  }
    }
    @-moz-keyframes yin {
        0% {opacity:1 }
        100% {opacity:0  }

    }

    @-moz-keyframes vertical-animation {
        0% { transform: translateY(0px);     }
        100% { transform: translateY(-290px); }
    }
    @-webkit-keyframes vertical-animation {
        0% { transform: translateY(0px);     }

        100% { transform: translateY(-290px); }
    }

    .home {
        height: 100%;
    }
    .guang{
    width: 100%;

    }
    body {
        background: #eee;
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14px;
        color: #000;
        margin: 0;
        padding: 0;
    }

    .swiper-container {
        width: 100%;
        height: 100%;

    }

    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        position: relative;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }

    .page1 {
        background: #020E1A;
        position: relative;
    }

    .logo {
        width: 236px;

        position: absolute;
        top: 71px;
        left: 494px;
    }

    .pl {
        position: absolute;
        width: 1227px;
        bottom: 0;
        left: 0;
    }

    .pr {
        position: absolute;
        width: 582px;
        top: 0;
        right: 0;
    }

    .pb {
        position: absolute;
        width: 1383px;
        bottom: 0;
        right: 0;
    }

    .nav {
        width: 189px;
        height: 189px;
        position: absolute;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;

    }


    .page1 .q1 {
        background-size: 100% 100%;
        left: 757px;
        top: 363px;
    }
     .nav:hover .quan{
        transform: rotate(180deg);
        transition: all 0.6s;

    }

     .nav:hover   .mT {
        transform: scale(1.1);
        transition: all 0.6s;

    }
    .page1 .q2 {
        background-size: 100% 100%;
        left: 1008px;
        top: 284px;
    }

    .page1 .q3 {
        background-size: 100% 100%;
        left: 1213px;
        top: 459px;
    }

    .page2 .p2 {
        position: absolute;
        width: 818px;
        top: 256px;
        left: 814px;
    }

    .page2 .p1 {
        position: absolute;
        width: 412px;
        top: 519px;
        left: 1364px;
        z-index: 2;
    }

    .page2 .p3 {
        width: 529px;
        top: 670px;
        right: 774px;
        z-index: 2;
    }

    .p2-wrap {
        position: absolute;
        width: 700px;
        top: 670px;
        right: 774px;
        z-index: 2;

    }

    .page2 .p3-g {
        width: 143px;
        z-index: 3;
        margin-bottom: 36px;
        margin-right: -18px;
    }

    .page2 .msg {
        position: absolute;
        width: 382px;
        top: 283px;
        left: 247px;
        z-index: 2;

    }

    .page3 .p1 {
        position: absolute;
        width: 1050px;
        top: 198px;
        left: 286px;
    }

    .page3 .p2 {
        position: absolute;
        width: 641px;
        top: 334px;
        left: 153px;
        z-index: 2;

    }

    .page3 .p3 {
        position: absolute;
        width: 151px;
        top: 406px;
        right: 841px;
        z-index: 2;
    }

    .page3 .msg {
        position: absolute;
        width: 315px;
        top: 283px;
        left: 1144px;
        z-index: 2;
    }

    .page4 .p1 {
        position: absolute;
        height: 63.2%;
        width: 100%;
        bottom: 0;
        left: 0;
    }

    .page4 .p2 {
        position: absolute;
        width: 451px;
        top: 220px;
        left: 1169px;
        z-index: 2;

    }

    .page4 .p3 {
        position: absolute;
        width: 548px;
        top: 108px;
        left: 1139px;
        z-index: 2;
    }

    .page4 .msg {
        position: absolute;
        width: 664px;
        top: 446px;
        left: 265px;
        z-index: 2;
    }
    .footer{
        position: absolute;
      bottom: 40px;
        z-index: 10;
        color: #fff;
        left: 1310px;

    }
    
    /* Page2-game styles - consistent with index page design */
    .page2-game {
        background: transparent;
        position: relative;
        overflow: hidden;
    }
    
    .page2-game .game-section{
        position: relative;
        z-index: 2;
        width: 90%;
        max-width: 1400px;
        margin: 0 auto;
        padding: 40px 50px;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 0;
        box-shadow: 0 20px 60px rgba(0,0,0,0.1);
        cursor: pointer;
        transition: all 0.4s ease;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 35px;
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.2);
    }
    
    .page2-game .game-section:hover{
        transform: translateY(-10px) scale(1.02);
        box-shadow: 0 30px 80px rgba(0,0,0,0.2);
        background: rgba(255, 255, 255, 0.98);
    }
    
    .page2-game .game-text{
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    
    .page2-game .game-title{
        font-size: 42px;
        color: #2d3748;
        font-weight: 800;
        text-shadow: 0 2px 4px rgba(0,0,0,0.1);
        line-height: 1.2;
        margin: 0;
    }
    
    .page2-game .game-desc{
        font-size: 18px;
        color: #4a5568;
        line-height: 1.6;
        max-width: 900px;
        margin: 0 auto;
    }
    
    .page2-game .game-media{
        display: flex;
        gap: 30px;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        margin: 0 auto;
    }
    
    .page2-game .game-cover-left{
        width: 455px;
        height: 200px;
        border-radius: 16px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.15);
        object-fit: cover;
        transition: all 0.3s ease;
        border: 3px solid rgba(255, 255, 255, 0.8);
        background: #fff;
    }
    
    .page2-game .game-cover,
    .page2-game .game-cover-small{
        width: 350px;
        height: 200px;
        border-radius: 16px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.15);
        object-fit: cover;
        transition: all 0.3s ease;
        border: 3px solid rgba(255, 255, 255, 0.8);
        background: #fff;
    }
    
    .page2-game .game-cover-left:hover,
    .page2-game .game-cover:hover,
    .page2-game .game-cover-small:hover{
        transform: translateY(-5px) scale(1.05);
        box-shadow: 0 15px 40px rgba(0,0,0,0.25);
    }
    
    @media (max-width: 768px){
        .page2-game .game-section{
            padding: 30px 25px;
            margin: 20px;
            gap: 25px;
        }
        .page2-game .game-title{
            font-size: 32px;
        }
        .page2-game .game-desc{
            font-size: 16px;
        }
        .page2-game .game-media{
            gap: 20px;
        }
        .page2-game .game-cover-left{
            width: 325px;
            height: 140px;
        }
        
        .page2-game .game-cover,
        .page2-game .game-cover-small{
            width: 250px;
            height: 140px;
        }
    }
    
    @media (max-width: 480px){
        .page2-game .game-section{
            padding: 25px 20px;
            margin: 15px;
            gap: 20px;
        }
        .page2-game .game-title{
            font-size: 26px;
        }
        .page2-game .game-desc{
            font-size: 14px;
        }
        .page2-game .game-cover-left{
            width: 234px;
            height: 100px;
        }
        
        .page2-game .game-cover,
        .page2-game .game-cover-small{
            width: 180px;
            height: 100px;
        }
    }
</style>
